import { render, staticRenderFns } from "./product_extra_input.vue?vue&type=template&id=4ca85eee&scoped=true&"
import script from "./product_extra_input.vue?vue&type=script&lang=js&"
export * from "./product_extra_input.vue?vue&type=script&lang=js&"
import style0 from "./product_extra_input.vue?vue&type=style&index=0&id=4ca85eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca85eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca85eee')) {
      api.createRecord('4ca85eee', component.options)
    } else {
      api.reload('4ca85eee', component.options)
    }
    module.hot.accept("./product_extra_input.vue?vue&type=template&id=4ca85eee&scoped=true&", function () {
      api.rerender('4ca85eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_extra_input.vue"
export default component.exports